<template>
  <ul class="report-area">
    <li class="report-area__header">
      <h2 class="report-area__header-title">Динамика постов по сетям</h2>

      <date-controls @onChooseDate="handleChangeDate"></date-controls>
    </li>
    <template v-if="reqPending">
      <table-preloader />
    </template>
    <template v-else>
      <template v-if="isData">
        <li class="report-area__report">
          <line-chart
            :chart-data="dataLineCollection"
            :options="lineOptions"
            class="dynamic-chart"
          ></line-chart>
        </li>
        <li class="report-area__header">
          <h2 class="report-area__header-title">Динамика тональности</h2>
        </li>

        <li class="report-area__report">
          <bar-chart
            :chart-data="dataBarCollection"
            :options="barOptions"
            class="tonality-chart"
            :height="300"
          ></bar-chart>
        </li>
      </template>
      <li v-else>
        Данных по этой ленте нет.
      </li>
    </template>
  </ul>
</template>

<script>
// api
import { getTrustHourlyApi } from '../../../../api/graphics';
import { getTrustDailyApi } from '../../../../api/graphics';

// bus
import { bus } from '../../../../bus.js';

// components
import { LineChart, BarChart } from '../../../../components/postsDynamicChart';
import TablePreloader from '../../../../components/preLoaders/tablePreloader.vue';
import DateControls from './components/DateControls.vue';

// mixins
import chartMixin from './mixins/chart';

export default {
  name: 'DynamicChart',
  data() {
    return {
      method: '',
      reqPending: false,
      isData: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getTrustHourly(this.$route.params.id);
    });
  },
  methods: {
    handleChangeDate({ method, range, prepareLabels, activePeriod }) {
      this[method](this.$route.params.id, range, prepareLabels);
      this.$emit('onGetPeriod', activePeriod);
    },
    getTrustHourly(id, range = null, prepareLabels) {
      this.reqPending = true;
      const params = this.setParams(id, range);

      getTrustHourlyApi(params)
        .then((response) => {
          this.reqPending = false;
          console.log(response.data);
          if (response.data.total.total.length) {
            this.isData = true;
          }
          this.dataLineCollection = this.prepareLineChartData(response, prepareLabels);
          this.dataBarCollection = this.prepareBarChartData(response, prepareLabels);
        })
        .catch(err => err);
    },
    getTrustDaily(id, range = null, prepareLabels) {
      this.reqPending = true;
      const params = this.setParams(id, range);

      getTrustDailyApi(params)
        .then((response) => {
          this.reqPending = false;
          this.dataLineCollection = this.prepareLineChartData(response, prepareLabels);
          this.dataBarCollection = this.prepareBarChartData(response, prepareLabels);
        })
        .catch(err => err);
    },
  },
  watch: {
    $route(val) {
      if (val.params.threadName) {
        this.getTrustHourly(this.$route.params.id);
        bus.$emit('restartPeriod');
      }
    },
  },
  components: {
    LineChart,
    TablePreloader,
    DateControls,
    BarChart,
  },
  mixins: [
    chartMixin,
  ],
};
</script>

<style>
  @import "css/graphics.css";
</style>
